var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewMyWorkingPattern01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 89 89",
    style: {
      enableBackground: "new 0 0 89 89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#FCBC00;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.9,67.2c-7.2,0-5.8,0-13,0c-0.2-0.1-0.4-0.1-0.7-0.2c-2.8-0.7-4.7-3.1-4.7-6c0-5.5,0-11.1,0-16.6 c0-6.2,0-12.5,0-18.7c0-2.9,1.9-5.3,4.7-6c1-0.2,2.1-0.1,3.2-0.2c0.2,0,0.4,0,0.7,0c0-1.4,0-2.7,0-4c1.3,0,2.6,0,4.1,0 c0,1.3,0,2.6,0,3.9c9,0,17.8,0,26.8,0c0-1.3,0-2.6,0-3.9c1.4,0,2.7,0,4.1,0c0,1.3,0,2.6,0,4c0.8,0,1.7,0,2.5,0 c2,0.1,3.5,0.9,4.7,2.4c0.7,0.9,1,2,1.2,3c0,5.8,0,11.5,0,17.4c0.1,0.5,0.1,2.8-0.4,1.5c-1-1.5-2-2.2-3.2-3.8 c-0.3-0.3-0.5-1.4-0.5-1.9c0-1.2,0-2.4,0-3.7c-14.6,0-29.1,0-43.7,0c0,0.2,0,0.4,0,0.6c0,8.5,0,17.1,0,25.6c0,1.7,0.8,2.4,2.5,2.4 c5.2,0,2.9,0,8.1,0c0.8,0,5.7-0.2,6.1,0.6 M55.9,23.7c-9,0-17.8,0-26.8,0c0,1.3,0,2.6,0,3.9c-1.3,0-2.6,0-4.1,0c0-1.3,0-2.6,0-4 c-0.8,0-1.6,0-2.4,0c-1.2,0-2.1,0.8-2.1,2.1c0,1.2,0,2.3,0,3.6c0,0.4,0,0.8,0,1.1c14.6,0,29.1,0,43.7,0c0-1.7,0-3.3,0-4.9 c0-0.9-0.8-1.8-1.7-1.9c-0.9-0.1-1.8,0-2.7,0c0,1.3,0,2.6,0,3.9c-1.3,0-2.6,0-4.1,0C55.9,26.3,55.9,25,55.9,23.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.3,42.8c-1.3,0-2.6,0-4,0c0-1.3,0-2.6,0-3.9c1.3,0,2.6,0,4,0C28.3,40.1,28.3,41.4,28.3,42.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.4,42.8c-1.3,0-2.6,0-4,0c0-1.3,0-2.6,0-3.9c1.3,0,2.6,0,4,0C36.4,40.1,36.4,41.4,36.4,42.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.5,38.8c1.3,0,2.6,0,4,0c0,1.3,0,2.6,0,3.9c-1.3,0-2.6,0-4,0C40.5,41.4,40.5,40.2,40.5,38.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.3,50.8c0-1.3,0-2.6,0-3.9c1.3,0,2.6,0,4,0c0,1.3,0,2.6,0,3.9C27,50.8,25.6,50.8,24.3,50.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.4,50.9c-1.3,0-2.6,0-4,0c0-1.3,0-2.6,0-3.9c1.3,0,2.6,0,4,0C36.4,48.1,36.4,49.5,36.4,50.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.3,54.9c0,1.3,0,2.6,0,3.9c-1.3,0-2.6,0-4,0c0-1.3,0-2.6,0-3.9C25.6,54.9,27,54.9,28.3,54.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.4,58.9c0-1.3,0-2.6,0-3.9c1.3,0,2.6,0,4,0c0,1.3,0,2.6,0,3.9C35.1,58.9,33.7,58.9,32.4,58.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.5,73.5v-4.2c0-5.6-11.4-8.5-17.1-8.5s-17.1,2.8-17.1,8.5v4.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.7,40.3c0.5,0,0.9,0,1.4,0c0.4,0.1,0.8,0.1,1.1,0.2c2.1,0.4,4,1.2,5.6,2.6c2,1.8,3.2,3.9,3.7,6.5 c0.1,0.4,0.1,0.8,0.2,1.2c0,0.5,0,0.9,0,1.4c0,0.1,0,0.1,0,0.2c-0.1,1.7-0.7,3.4-1.5,4.9c-1.8,2.9-4.3,4.7-7.7,5.3 c-0.4,0.1-0.8,0.1-1.2,0.2c-0.5,0-0.9,0-1.4,0c-0.3,0-0.6-0.1-0.8-0.1c-2.3-0.3-4.2-1.2-5.9-2.7c-2-1.7-3.2-3.8-3.7-6.5 c-0.1-0.4-0.1-0.8-0.2-1.2c0-0.5,0-0.9,0-1.4c0.1-0.4,0.1-0.8,0.2-1.1c0.4-2.3,1.4-4.3,3.1-6c1.7-1.7,3.7-2.8,6.1-3.2 C53.9,40.4,54.3,40.4,54.7,40.3z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMyWorkingPattern01);
export default __webpack_public_path__ + "static/media/new-my-working-pattern-01.0cca5e0d7cd6305f9258ebcacc0f569d.svg";
export { ForwardRef as ReactComponent };